import styled from "styled-components";
import Button from "components/Button";
import { device } from "responsive";

export const FormStyled = styled.div`
  width: 100%;
  margin-left: 35px;

  @media ${device.sm} {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  @media ${device.xs} {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const ButtonForm = styled(Button)`
  font-size: 16px;
  height: 40px;
`;
